import PropTypes from "prop-types"
import { useRemarkSync } from "react-remark"
import { Link } from "react-router-dom"
import styled from "styled-components"

const A = styled(Link)`
  text-decoration: underline;

  &:focus,
  &:hover {
    text-decoration: none;
  }
`

const components = {
  a: ({ href, ...props }) => <A target="_blank" to={href} {...props} />,
  h1: ({ ...props }) => <h1 className="h2 mb-8" {...props} />,
  h2: ({ ...props }) => <h2 className="h3 mb-8" {...props} />,
  h3: ({ ...props }) => <h3 className="body-lg mb-8" {...props} />,
}

const DescriptionMarkdown = ({ children }) => {
  const markdownContent = useRemarkSync(children, {
    rehypeReactOptions: { components },
    supressHydrationWarning: true,
  })

  return markdownContent
}

DescriptionMarkdown.propTypes = {
  children: PropTypes.string,
}

export default DescriptionMarkdown
